import { baseApi } from '@/api/core/baseApi';
import { unwrapApiResponse } from '@/api/patterns/crud';
import type {
  PlatformSecurityAlertsResponse,
  GetSecurityAlertsArgs,
} from '../types';

export const securityAlertsApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getPlatformSecurityAlerts: builder.query<
      PlatformSecurityAlertsResponse,
      GetSecurityAlertsArgs | void
    >({
      query: (args) => {
        const params = new URLSearchParams();
        if (args) {
          if (args.page) params.set('page', String(args.page));
          if (args.limit) params.set('limit', String(args.limit));
          if (args.severity) params.set('severity', args.severity);
          if (args.alertType) params.set('alertType', args.alertType);
          if (args.category) params.set('category', args.category);
          if (args.organizationId) params.set('organizationId', args.organizationId);
          if (args.startDate) params.set('startDate', args.startDate);
          if (args.endDate) params.set('endDate', args.endDate);
        }
        const qs = params.toString();
        return `/platform/security-alerts${qs ? `?${qs}` : ''}`;
      },
      transformResponse: unwrapApiResponse<PlatformSecurityAlertsResponse>,
    }),
  }),
});

export const { useGetPlatformSecurityAlertsQuery } = securityAlertsApi;
